<!-- eslint-disable prettier/prettier -->
<template>
  <div v-if="companyList.length">
    <div
      class="comanpy-select-wrapper"
      @click="openPopup"
    >
     <div class="company-name">{{ companyName }}</div> 
      <maple-icon class="arrow-down" size="0.24rem" name="down_filled1" />
    </div>
    <van-popup v-model="showCompanyList" round position="bottom">
      <div class="popup-wrapper">
        <div class="popup-title">
          选择门店
          <div class="close-btn" @click="closePopup">
            <IconFont
              name="guanbi"
              size=".24rem"
              color="#666"
              class="icon-font"
            ></IconFont>
          </div>
        </div>
        <scroll-view class="scroll-view-wrapper">
          <div
            v-for="item in companyList"
            :key="item.companyId"
            class="company-item"
            @click="select(item)"
          >
            <div class="select-operate">
              <IconFont
                :name="
                  selected_company_id == item.companyId
                    ? 'xuankuang-gouxuan'
                    : 'xuankuang-weixuanzhong'
                "
                :color="selected_company_id == item.companyId ? '#15bb5c' : '#CCCCCC'"
                size="20px"
              ></IconFont>
            </div>
            <div class="info">
              <div class="name-wrapper">
                <template v-if="item.companyId != '-1'">
                  <img v-if="item.companyType == 1" class="company-tag" src="@/images/company/store.png" />
                  <img v-else-if="item.companyType == 0" class="company-tag" src="@/images/company/branch.png" />
                  <img v-else class="company-tag" src="@/images/company/shop.png">
                </template>
               
                <span class="name"> {{ item.companyName }}</span>
              </div>
              <div class="address">{{ item.address }}</div>
            </div>
          </div>
        </scroll-view>
      </div>
    </van-popup>
  </div>
</template>

<script>
import ScrollView from '@/common/widgets/scroll_view'
import { API } from '@/api'
export default {
  name: 'BillCompany',
  components: {
    ScrollView
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['page', 'billCompanyId'],
  data() {
    return {
      companyName: '',
      companyList: [],
      showCompanyList: false,
      selected_company_id: ''
    }
  },
  created() {
    if (this.page === 'bill') {
      this.getBillCompanyList()
    } else {
      this.getExportCompanyList()
    }
  },
  methods: {
    async getBillCompanyList() {
      try {
        const res = await API.tpPay.getBillCompanyList({
          queryFrom: 'bill'
        })
        const companyList = res?.companyList || []
        if (companyList.length) {
          this.companyList = companyList
          // eslint-disable-next-line camelcase
          const selected_company = this.companyList.find(
            item => !!item.isSelected
          )
          // eslint-disable-next-line camelcase
          const selected_company_id = selected_company?.companyId || ''
          // eslint-disable-next-line camelcase
          this.selected_company_id = selected_company_id
          // this.setBillSelectedCompanyId(selected_company_id)
          const companyName = selected_company?.companyName
          // eslint-disable-next-line camelcase
          this.companyName = companyName

          this.$emit('selectCompany', selected_company_id)
        } else {
          this.$emit('selectCompany', '')
        }
      } catch (e) {
        this.$emit('selectCompany', '')
      }
    },
    async getExportCompanyList() {
      try {
        const res = await API.tpPay.getBillCompanyList({
          queryFrom: 'bill'
        })
        const companyList = res?.companyList || []
        if (companyList.length) {
          this.companyList = companyList
          this.selected_company_id = this.billCompanyId
          // eslint-disable-next-line camelcase
          const selected_company = this.companyList.find(
            // eslint-disable-next-line eqeqeq
            item => item.companyId == this.billCompanyId
          )
          // this.setBillSelectedCompanyId(selected_company_id)
          const companyName = selected_company?.companyName
          // eslint-disable-next-line camelcase
          this.companyName = companyName
          this.$emit('selectCompany', this.selected_company_id)
        } else {
          this.$emit('selectCompany', '')
        }
      } catch (e) {
        this.$emit('selectCompany', '')
      }
    },

    openPopup() {
      this.showCompanyList = true
    },
    select(item) {
      // this.setBillSelectedCompanyId(item.companyId)
      this.selected_company_id = item.companyId
      this.companyName = item.companyName
      this.showCompanyList = false
      this.$emit('selectCompany', item.companyId)
    },
    closePopup() {
      this.showCompanyList = false
    }
  }
}
</script>

<style lang="scss" scoped>
.comanpy-select-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 44px;
  padding-left: 0.4rem;
  padding-right: 0.46rem /* 23/50 */;
  background-color: #fff;
  .arrow-down {
    margin-left: 2px;
  }
  .company-name {
    max-width: 4rem /* 200/50 */;
    @include text-overflow-ellipsis;
    @include text(0.28rem /* 14/50 */, #262626);
  }
}

.popup-wrapper {
  height: 80vh;
  display: flex;
  flex-direction: column;

  .popup-title {
    height: 1.04rem /* 52/50 */;
    position: relative;
    @include flex-row-center;
    @include text(0.32rem /* 16/50 */, #333333, true);
    .close-btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0.2rem /* 10/50 */;
      top: 50%;
      margin-top: -10px;
    }
  }
  .scroll-view-wrapper {
    flex: auto;
    height: 0;
    padding-bottom: 0.4rem /* 20/50 */;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.company-item {
  @include flex-row-center;
  margin: 0 0.32rem /* 16/50 */;
  padding: 0.32rem /* 16/50 */ 0;
  /* 15/50 */
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #f6f6f6;
  .company-tag {
    width: 26px;
    height: 14px;
    margin-right: 0.12rem /* 6/50 */;
  }

  .info {
    flex: auto;
    width: 0;
    margin-left: 0.24rem /* 12/50 */;
    .name-wrapper {
      @include flex(row, normal, center);
      .tag {
        width: 0.52rem /* 26/50 */;
        height: 0.28rem /* 14/50 */;
        margin-right: 0.12rem /* 6/50 */;
      }
      .name {
        @include text(0.28rem /* 14/50 */, #262626, true);
        @include text-overflow-ellipsis;
      }
    }

    .address {
      @include text(14px, #999999);
      @include text-overflow-ellipsis;
      margin-top: 0.18rem /* 9/50 */;
    }
  }
}
</style>
